import {
  PageSizeOption,
  PageSizeSelector,
} from '@/features/product/components/molecules/PageSizeSelector';
import React, { useState } from 'react';

interface ProductPageSizeSelectorProps {
  onChange?: (value: number) => void;
  initialValue?: number;
  className?: string;
}

export const ProductPageSizeSelector: React.FC<
  ProductPageSizeSelectorProps
> = ({ onChange, initialValue = 10, className }) => {
  const [selectedPageSize, setSelectedPageSize] =
    useState<number>(initialValue);

  const pageSizeOptions: PageSizeOption[] = [
    { label: '10개', value: 10 },
    { label: '20개', value: 20 },
  ];

  const handlePageSizeChange = (value: string | number) => {
    const pageSizeValue =
      typeof value === 'string' ? parseInt(value, 10) : value;
    setSelectedPageSize(pageSizeValue);
    onChange?.(pageSizeValue);
  };

  return (
    <PageSizeSelector
      label="목록"
      options={pageSizeOptions}
      selectedValue={selectedPageSize}
      onChange={handlePageSizeChange}
      className={className}
    />
  );
};
